import React, { useState } from 'react';
import { ElementType, formatText } from '..';
import { buildStructuredList } from 'services/utils';
import './style.css';

const HtmlPreview = ({ elements }) => {
	const [collapsed, setCollapsed] = useState(true);
	return (
		<pre className={`code-preview ${collapsed ? 'collapsed' : ''}`}>
			<button className="collapsed-btn" onClick={() => setCollapsed(!collapsed)}>
				{collapsed ? '+' : '-'}
			</button>
			{elements
				.map(el => {
					const classAttr = el?.className ? ` class="${el.className}"` : '';
					const headingElements = new Set([ElementType.MAIN_TITLE, ElementType.NORMAL_TITLE, ElementType.SUB_TITLE]);
					// Handle Main Title (h3) & Sub Title (h6) (No Wrapper)
					if (headingElements.has(el.type)) {
						return `<${el.type}${classAttr}>${formatText(el.content)}</${el.type}>`;
					}

					// Handle Unordered & Ordered Lists
					if ([ElementType.ORDERED_LIST, ElementType.UNORDERED_LIST].includes(el.type)) {
						const structuredList = buildStructuredList(el.content, el.nestedIndexes);
						const listTitle = el.listTitle ? `<div class="list-title ${el?.className}">${el.listTitle}</div>\n` : '';
						const listItems = structuredList
							?.map(item => {
								const childrenHtml =
									item?.children?.length > 0
										? `<${el.type}>
													${item.children.map(child => `\t<li>${formatText(child)}</li>`).join('\n')}
													</${el.type}>`
										: '';

								return `<li>
						\t<span>${formatText(item.parent)}</span>
						\t${childrenHtml}
						</li>`;
							})
							.join('\n');
						return `<div>\n${listTitle}<${el.type}>\n${listItems}\n</${el.type}>\n</div>`;
					}
					if ([ElementType.LINE_BREAK].includes(el.type)) {
						return `<br/><br/>`;
					}

					if ([ElementType.PARAGRAPH].includes(el.type)) {
						let _formattedText = formatText(el.content);

						if (el.selectedHighlightText && el.linkUrl) {
							const _link = `<a href="${el.linkUrl}" target="_blank" rel="noopener noreferrer">${el.selectedHighlightText}</a>`;
							_formattedText = _formattedText?.replace(formatText(el.selectedHighlightText), _link);
						}
						return `<p${classAttr}>${_formattedText}</p>`;
					}
					// Handle Article Type (Ensure Only Title Gets Toolbar Formatting)
					if ([ElementType.ARTICLE].includes(el.type)) {
						return `
<div class="article">
<h6 class="${el.className}">${formatText(el.title)}</h6>
<p>${el.body.replace(/\n/g, '<br><br>')}</p>
</div>`;
					}
					if ([ElementType.MULTIPLE_CHOICE].includes(el.type)) {
						const choices = el.answers
							.map(
								(answer, i) => `
<div class="multiple-choice-option">
    <input type="checkbox" id="choice-${el.id}-${i}" name="question-${el.id}"
    class="${answer.isCorrect ? 'correct-answer' : 'wrong-answer'}"
    onclick="document.querySelectorAll('[name=question-${el.id}]').forEach(cb => { if (cb !== this) cb.checked = false; })">
    
    <label for="choice-${el.id}-${i}">${answer.text}</label>
    ${!answer.isCorrect ? `<p class="hint">${answer.hint}</p>` : ''}
</div>`
							)
							.join('');
						return `
<div class="multiple-choice">
<h6>${el.questionTitle}</h6>
${choices}
</div>`;
					}
					if (el.type === ElementType.TABLE) {
						return `
					<table>
					  ${el?.tableData?.title ? `<caption ${classAttr}>${el?.tableData.title}</caption>` : ''}
					  <thead>
						<tr>
						  ${el?.tableData?.headers?.map(header => `<th>${header}</th>`).join('')}
						</tr>
					  </thead>
					  <tbody>
						${Array.from({ length: el?.tableData?.rows[el?.tableData.headers[0]]?.length })
							.map((_, rowIdx) => {
								return `
								<tr>
								  ${el?.tableData.headers.map(header => `<td>${el?.tableData.rows[header][rowIdx] || ''}</td>`).join('')}
								</tr>
							  `;
							})
							.join('')}
					  </tbody>
					</table>
					`;
					}
					if ([ElementType.VIDEO].includes(el.type)) {
						return `
<div class="video">
    <iframe
        src="${el.videoFullSrcPath}" 
        width="100%"
        height="100%"
        allowfullscreen>
    </iframe>
</div>`;
					}
					if ([ElementType.AUDIO].includes(el.type)) {
						return `
<div class="audio">
    <iframe
        src="${el.audioFullSrcPath}" 
        width="100%"
        height="100%"
    </iframe>
</div>`;
					}
					if ([ElementType.IMAGE].includes(el.type)) {
						return `
<img src="${el.imageSrc}" alt="image-${el.id}" />`;
					}

					// Handle Paragraphs and Other Text Elements
					return `<div${classAttr}>${formatText(el.content)}</div>`;
				})
				.join('\n')}
		</pre>
	);
};

export default HtmlPreview;
